import React, { useMemo } from 'react';
import { useMilestoneCelebrations } from '../../hooks/useMilestoneCelebrations';
import { MissionsSection } from './MissionsSection';
import MilestoneItem from './MilestoneItem';

/**
 * Unreached milestones; completed ones celebrate then leave.
 */
export const MilestonesList = ({
  entries = [],
  totalMilestoneCount = 0,
  tasks = [],
  statuses = [],
  nestedSprints = [],
  isCollapsed,
  onToggle,
  onGoToTask,
  onMissionHover,
  onMissionLeave,
}) => {
  const { displayItems } = useMilestoneCelebrations(entries, { tasks, statuses, nestedSprints });
  const visibleCount = entries.length;

  const emptyMessage = useMemo(() => {
    if (totalMilestoneCount === 0) return 'No milestones yet';
    if (visibleCount === 0 && displayItems.length === 0) return 'All milestones reached!';
    return 'No milestones yet';
  }, [totalMilestoneCount, visibleCount, displayItems.length]);

  return (
    <MissionsSection
      title="MILESTONES"
      count={visibleCount}
      isCollapsed={isCollapsed}
      onToggle={onToggle}
      variant="milestones"
    >
      {displayItems.length === 0 ? (
        <div className="flowchart-hud__missions-empty">{emptyMessage}</div>
      ) : (
        displayItems.map((item) => (
          <div
            key={item.milestone.id}
            className={[
              'flowchart-hud__milestone-slot',
              item.celebrationPhase === 'exit' && 'flowchart-hud__milestone-slot--exit',
            ].filter(Boolean).join(' ')}
          >
            <div className="flowchart-hud__milestone-slot-inner">
              <MilestoneItem
                entry={item}
                celebrationPhase={item.celebrationPhase}
                onGoToTask={onGoToTask}
                onMouseEnter={() => onMissionHover?.(item.milestone.id)}
                onMouseLeave={() => onMissionLeave?.()}
              />
            </div>
          </div>
        ))
      )}
    </MissionsSection>
  );
};
